import {Link} from "react-router";
import {useContext} from "react";
import {Loading} from "../components/loading.tsx";

import GeneralContext from "../contexts/Gneral.tsx";

export function Intro () {
    const {contents}  = useContext(GeneralContext);
    return (<div  className={'builder-screen'}>
            <div className={'selectingAside centered'}>
                <div className={'introContent'}>
                    <h1>{contents.introScreenHeading}</h1>
                    <p>{contents.introScreenContent}</p>
                    <Link to="/select-avatar" className={'btn'}>התחלה</Link>
                </div>
            </div>
            <div className={'visualArea'}>
                <div className={'personArea initial'}>
                    <span className={'personItem'}>אני</span>
                </div>
            </div>
        </div>);
}